import { render, staticRenderFns } from "./creatext.vue?vue&type=template&id=2df8218a&"
import script from "./creatext.vue?vue&type=script&lang=js&"
export * from "./creatext.vue?vue&type=script&lang=js&"
import style0 from "./creatext.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports